import React from 'react'

import { Box, Heading2 } from '@gousto-internal/citrus-react'

type CollectionTitleProps = {
  text: string
}

export const CollectionTitle = ({ text }: CollectionTitleProps) => (
  <Box paddingBottom={2}>
    <Heading2>{text}</Heading2>
  </Box>
)
